import { makeStyles } from 'tss-react/mui';

interface StylesProps {
  rows: number;
  wordBreak: 'normal' | 'break-all' | 'keep-all' | 'break-word';
  hyphens?: boolean;
  maxWidth?: number;
}

const useStyles = makeStyles<StylesProps>()(
  (_, { rows, wordBreak, hyphens, maxWidth }) => ({
    ellipsis: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: '-webkit-box !important',
      WebkitLineClamp: rows,
      WebkitBoxOrient: 'vertical',
      overflowWrap: 'break-word',
      wordBreak: wordBreak,
      whiteSpace: 'normal',
      hyphens: hyphens ? 'auto' : 'none',
      maxWidth: maxWidth,
    },
  }),
);

export default useStyles;
